// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientHistory_container__3USca","empty":"ClientHistory_empty__r-shB"};